/**
 * @generated SignedSource<<46ceb5f27d1864e660d150719bab138d>>
 * @relayHash 9ad98f9c176b1595865f5d74268d43ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c961e67f99fd999108e497a76217794af6274f72495c30bec4764392d3f3a8ff

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentBrowseStandardFlowsQuery } from './VirtualAgentBrowseStandardFlowsQuery.graphql';

import checkForAiEnabledFF_provider from '@jira/platform__graphql-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentBrowseStandardFlowsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c961e67f99fd999108e497a76217794af6274f72495c30bec4764392d3f3a8ff",
    "metadata": {},
    "name": "VirtualAgentBrowseStandardFlowsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
